export const GOAL_TYPE = {
  UNDER_ME_NEXT_COMPETENCY: 'underMeNextCompetency',
  CUSTOM: 'custom'
};
